/** API route map: URLS.Controller.ClientBillingRateOverrides */
export const ClientBillingRateOverrides = {
      Name: 'ClientBillingRateOverrides/',
      Add: 'add',
      Get: 'get',
      Update: 'update',
      Delete: 'delete',
};
